import React from 'react';
import { Card } from 'react-bootstrap';

import GenericSimpleRenderItems from './GenericSimpleRenderItems';

const ComplementoCartaPorteAutotransporteResumen = ({ data = {} }) => {

  return (
    <>
      { !!data.Mercancias.Autotransporte && (
        <>
          <div className="d-block mt-3 mb-2">
            <strong>Autotransporte</strong>
          </div>

          <Card className="mb-2">
            <Card.Body>
              <GenericSimpleRenderItems
                data={ data.Mercancias.Autotransporte }
                labels={ labels }
              />
            </Card.Body>
          </Card>
        </>
      ) }
    </>
  )
}

const labels = [
  {
    label: 'Perm SCT',
    index: 'PermSCT'
  },
  {
    label: 'Número Permiso SCT',
    index: 'NumPermisoSCT',
  },
  {
    label: 'Configuración Vehicular',
    index: 'IdentificacionVehicular.ConfigVehicular',
  },
  {
    label: 'Placa Vehículo Motor',
    index: 'IdentificacionVehicular.PlacaVM',
  },
  {
    label: 'Año Modelo Vehículo Motor',
    index: 'IdentificacionVehicular.AnioModeloVM'
  },
  {
    label: 'Aseg. Responsabilidad Civil',
    index: 'Seguros.AseguraRespCivil'
  },
  {
    label: 'Póliza Responsabilidad Civil',
    index: 'Seguros.PolizaRespCivil'
  },
  {
    label: 'Aseg. Daños Medio Ambiente',
    index: 'Seguros.AseguraMedAmbiente'
  },
  {
    label: 'Póliza Daños Medio Ambiente',
    index: 'Seguros.PolizaMedAmbiente'
  },
  {
    label: 'Aseg. Carga Transportada',
    index: 'Seguros.AseguraCarga'
  },
  {
    label: 'Póliza Carga Transportada',
    index: 'Seguros.PolizaCarga'
  },
  {
    label: 'Valor Primaa Seguro',
    index: 'Seguros.PrimaSeguro'
  }
];

export default ComplementoCartaPorteAutotransporteResumen;
